<span
  class="bullet bullet-dot"
  [coreCustomTooltip]="tooltip()"
  [class]="'h-8px w-8px cursor-pointer ' + class()"
  >{{ text() }}</span
>
